import { Button, Dialog, DialogTitle, Paper, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SaveChangesModalBodyOne from "./SaveChangesModalBodyOne";
import SaveChangesModalBodyTwo from "./SaveChangesModalBodyTwo";

interface Props {
  openModal: boolean;
  handleClose: () => void;
}

const SaveChangesModal = ({ openModal, handleClose }: Props) => {
  return (
    <>
      <Dialog
        open={openModal}
        onClose={handleClose}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper>
          <Box
            sx={{
              padding: "16px 24px 20px 24px",
              borderBottom: "1px solid #0000001F",
            }}
          >
            <DialogTitle sx={{ padding: "0px 0px 5px 0px" }}>
              Changes In Brand Configuration
            </DialogTitle>
            <Typography variant="body2" color="#00000061">
              Awin Sport UK (4567) ● <span>IncomeAccess</span>{" "}
            </Typography>
          </Box>

          <SaveChangesModalBodyOne />
          <SaveChangesModalBodyTwo />

          <Stack
            flexDirection={"row"}
            justifyContent={"end"}
            gap={1}
            sx={{
              padding: "16px 24px 20px 24px",
              borderTop: "1px solid #0000001F",
            }}
          >
            <Button variant="text" color="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="contained" color="secondary" onClick={handleClose}>
              validate & save
            </Button>
            <Button
              variant="contained"
              //disabled
              color="secondary"
              endIcon={<SaveOutlinedIcon />}
            >
              save
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default SaveChangesModal;
